'use client';

import Link from 'next/link';
import React from 'react';

import { ArticleCardProps } from './types';
import { Button } from '../../button';
import { Chip } from '../../chip';

import IconLinkButton from '@/assets/icons/iconLinkButton.svg';

export const ArticleCard = ({
  labelId,
  descriptionId,
  label,
  img,
  chips,
  description,
  tags,
  urlArticle,
  variant = 'article',
  width,
  height,
}: ArticleCardProps) => (
  <Link href={urlArticle!} className="block h-full w-full">
    <div className="relative h-full rounded-20 bg-surfaceBaseSecondary hover:cursor-pointer max-sm:h-fit max-sm:hover:cursor-default">
      <div className="absolute left-0 top-0 h-full w-full rounded-20 bg-gradient-to-l from-[rgba(255,255,255,0.192)] to-transparent opacity-0 transition-opacity duration-300 hover:opacity-100" />
      <div className="flex h-full w-full flex-col justify-start rounded-20 px-2 pb-5 pt-2 max-sm:h-fit">
        {img && (
          <div className="relative h-auto w-full rounded-xl">
            {chips && chips.length > 0 && (
              <div className="absolute z-10 flex w-full justify-between p-3">
                <div className="flex flex-wrap gap-3 max-sm:gap-2">
                  {chips.map((chip, index) => (
                    <Chip label={chip} key={index} />
                  ))}
                </div>
                <div className="h-10 w-10 rounded-xl bg-customSurfaceContrastLow p-2 text-textBasePrimary backdrop-blur-2xl max-sm:hidden">
                  <IconLinkButton />
                </div>
              </div>
            )}
            <img
              src={img}
              className="pointer-events-none w-full rounded-xl"
              alt="Card image"
              width={width || 0}
              height={height || 0}
              decoding="async"
              loading="lazy"
            />
          </div>
        )}
        {tags && (
          <div className="mt-4 flex flex-wrap gap-2 px-3 max-sm:gap-[6px]">
            {tags.map((tag, index) => (
              <div key={index}>
                <p className="flex items-center whitespace-nowrap text-[14px] leading-[18px] text-textBaseSecondary max-sm:text-xs">
                  {tag}
                  {index !== tags.length - 1 && (
                    <span className="ml-2 h-[8px] w-[8px] rounded-[50%] bg-textBaseSecondary max-sm:ml-[6px]" />
                  )}
                </p>
              </div>
            ))}
          </div>
        )}
        <p
          id={labelId}
          className="mx-3 mt-3 text-[18px] font-medium leading-[24px]"
        >
          {label}
        </p>
        {description && (
          <p
            id={descriptionId}
            className="mx-3 mt-3 text-[16px] leading-[24px] text-textBaseSecondary"
          >
            {description}
          </p>
        )}
        {variant === 'article' && urlArticle && (
          <Button
            onClick={() => (window.location.href = urlArticle!)}
            className="mt-5 hidden justify-center px-4 max-sm:flex"
            variant="secondary"
            ariaLabel="Читать историю"
          >
            <div className="g-1 flex">
              Читать историю
              <IconLinkButton />
            </div>
          </Button>
        )}
      </div>
    </div>
  </Link>
);
